/**
 * v0.3 業態初期表示の自動選択 (migration 0033): AiMenuChatPage の useEffect が使う判定ロジックを
 * 純粋関数として切り出したもの。@cloudflare/vitest-pool-workers が OneDrive パスで使えない制約
 * (§8-58) があるため、SQL側 (GET /menu-dev/default-industry) はコードレビューでのみ担保し、
 * フロント側で切り出せるこの判定部分は実テストでカバーする。
 * 設計: docs/design/v03-ai-menu-dev-industry-auto-default.md §5.2
 */
export type AutoIndustryDecisionInput = {
  /** 表示中の既存セッションID。存在する場合は新規セッション向けの自動選択を一切行わない */
  sessionId: string | null;
  /** このコンポーネントインスタンスで既に自動適用済みか (1度だけ適用するためのガード) */
  autoAlreadyApplied: boolean;
  /** ユーザーが手動で選択中の業態ID (空文字は未選択) */
  manuallySelectedIndustryId: string;
  /** GET /menu-dev/default-industry のレスポンス由来の業態ID */
  defaultIndustryTemplateId: string | null | undefined;
  /** GET /menu-dev/industry-templates で取得済みの業態ID一覧 */
  availableIndustryTemplateIds: string[];
};

/** 新規セッション画面で業態を自動選択すべきかどうかを判定する。
 *  defaultIndustryTemplateId が一覧未到着 (availableIndustryTemplateIds に含まれない) の場合は
 *  false を返し、呼び出し側は次のレンダーで再評価すること (レースガード、D&C H-3)。 */
export function shouldAutoApplyIndustry(input: AutoIndustryDecisionInput): boolean {
  if (input.sessionId) return false;
  if (input.autoAlreadyApplied) return false;
  if (input.manuallySelectedIndustryId) return false;
  if (!input.defaultIndustryTemplateId) return false;
  if (!input.availableIndustryTemplateIds.includes(input.defaultIndustryTemplateId)) return false;
  return true;
}
